import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { SaleItemGroupFragment } from 'graphql/SaleItemGroup/fragments/SaleItemGroupFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
/**
 * @fragment SaleItemWithRelationsListFragment
 * @since 1.0.0
 */
export const SaleItemWithRelationsListFragment = gql `
  fragment SaleItemWithRelationsListFragment on SaleItem {
    id
    sku
    price
    category
    configuration
    optionConfiguration
    active
    title
    summary
    infos

    group {
      ...SaleItemGroupFragment
    }

    groups {
      ...SaleItemGroupFragment
    }

    image {
      ...SaleItemImageFragment
    }

    images {
      ...SaleItemImageFragment
    }

    translations {
      id
      title
      summary
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }

    relations {
      id
      type
      quantity
      relatedSaleItem {
        id
        title
        price
        sku
        active
      }
    }
  }

  ${SaleItemImageFragment}
  ${SaleItemGroupFragment}
  ${LanguageFragment}
`;
